/**
 * Amount to charge now for an order.
 *
 * For partial_paid, derive remaining from current totalAmount minus already
 * captured payment.amount so EMR price/insurance edits stay correct even when
 * payment.delayedAmount is stale.
 */
export function resolveOrderChargeAmount(order: {
  totalAmount?: number;
  payment?: {
    status?: string;
    amount?: number;
    delayedAmount?: number;
  } | null;
}): number {
  const total = Math.round((order.totalAmount || 0) * 100) / 100;
  if (order.payment?.status === 'partial_paid') {
    const alreadyPaid = order.payment?.amount || 0;
    return Math.max(0, Math.round((total - alreadyPaid) * 100) / 100);
  }
  return total;
}

/**
 * Recompute payment.delayedAmount after EMR changes order totalAmount.
 * Returns undefined when the payment status does not carry a deferred balance.
 */
export function resolveDeferredAmountAfterTotalChange(
  payment:
    | {
        status?: string;
        amount?: number;
        delayedAmount?: number;
      }
    | null
    | undefined,
  newTotalAmount: number
): number | undefined {
  if (!payment?.status) {
    return payment?.delayedAmount;
  }

  const total = Math.round((newTotalAmount || 0) * 100) / 100;

  if (payment.status === 'partial_paid') {
    return Math.max(0, Math.round((total - (payment.amount || 0)) * 100) / 100);
  }

  if (
    payment.status === 'delayed_capture' ||
    payment.status === 'adjudicated'
  ) {
    return total;
  }

  return payment.delayedAmount;
}
